import { render, staticRenderFns } from "./ShareThisCardDialog.vue?vue&type=template&id=39ecb018&scoped=true&"
import script from "./ShareThisCardDialog.vue?vue&type=script&lang=js&"
export * from "./ShareThisCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareThisCardDialog.vue?vue&type=style&index=0&id=39ecb018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ecb018",
  null
  
)

export default component.exports